// extracted by mini-css-extract-plugin
export default {"Like":"LikeButton_Like__JZHDL","IsLiked":"LikeButton_IsLiked__SS9mo","count":"LikeButton_count__sow+j","TooltipContainer":"LikeButton_TooltipContainer__old4D"};